<template>
  <Card
    v-bind="$attrs"
    clickable
    :morph="invoice.timeline_morph"
    :pinned="invoice.timeline_pinned"
    :simple="simple"
    @click="viewingInvoiceID = invoice.id"
  >
    <q-item-section>
      <div class="text-caption text-bold q-mb-xs">
        <span v-if="fullDate" class="q-pr-xs">
          ({{ $formatSystemDate(invoice.timeline_date, luxonFormats.SHORT_WORDED_DATE) }})
        </span>
        Invoice
      </div>
      <q-item-label v-if="invoice.address" class="module-name">
        {{ invoice.address }}
      </q-item-label>
      <q-item-label caption>
        {{ invoice.invoice_number }}
      </q-item-label>
      <Status
        flat
        :invoice="invoice"
        class="q-mt-sm lt-sm"
      />
    </q-item-section>
    <q-item-section
      v-if="invoice.client"
      side
      class="text-right gt-xs"
      :title="invoice.client"
    >
      {{ truncateString(invoice.client) }}
    </q-item-section>
    <q-item-section
      side
      style="min-width: 90px;"
      class="text-right"
    >
      <q-item-label class="text-bold">
        {{ friendlyNumber(invoice.total, true) }}
      </q-item-label>
    </q-item-section>
    <q-item-section
      side
      style="min-width: 85px;"
      class="q-pl-sm gt-xs"
    >
      <Status :invoice="invoice" />
    </q-item-section>
  </Card>

  <InvoiceDialog
    :id="viewingInvoiceID"
    without-appointment
    without-client
    :disable-editing="false"
    @deleted="markArchived"
    @close="viewingInvoiceID = null"
  />
</template>

<script>
import { defineAsyncComponent } from 'vue'

import Status from 'components/app/invoicing/partials/Status'
import Card from 'components/partials/timeline/partials/Card'
import cardMixin from 'components/partials/timeline/partials/cardMixin'

export default {
  components: {
    Card,
    Status,
    InvoiceDialog: defineAsyncComponent(() => import('src/components/app/invoicing/partials/view/Dialog'))
  },
  mixins: [cardMixin],
  props: {
    invoice: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      viewingInvoiceID: null
    }
  },
  methods: {
    markArchived () {
      this.invoice.archived = true
    }
  }
}
</script>
